<template>
  <div class="service-content">
    <div class="content">
      <div class="item-title">{{isReworkOrder ? $t('asm_service_content.fu_wu_nei_rong') : $t('asm_service_content.gu_zhang_miao_shu') }}</div>
      <div
        class="img-content"
        v-if="imgList.length"
      >
        <div
          class="img-item"
          v-for="(item, index) in imgList"
          :key="index"
        >
          <el-image
            class="img"
            :src="getAttachUrl(item)"
            :preview-src-list="[getAttachUrl(item)]"
            fit="contain"
          >
          </el-image>
        </div>
      </div>
      <div class="case-order-desc">{{info.caseOrderDesc || (imgList.length ? '' : '-')}}</div>

    </div>
    <!-- 受理详情：当案例订单类型时显示 -->
    <div
      class="opinion"
      v-if="orderType === 'caseOrder'"
    >
      <div class="item-title">
        <span class="title">{{ $t('asm_service_content.shou_li_xiang_qing') }}</span>
        <i
          class="icon icon-bianji btn-edit"
          v-if="info.caseOrderState >=20 && info.caseOrderState <= 70"
          @click="onAccept"
        ></i>
      </div>
      <div class="opinion-item">
        <div class="opinion-item-title">{{ $t('asm_service_content.you_xian_ji') }}</div>
        <div class="opinion-item-content">{{ getDicValue('asm_close_priority',info.priority) || '-'}}</div>
      </div>
      <div class="opinion-item">
        <div class="opinion-item-title">{{ $t('asm_service_content.shou_li_bei_zhu') }}</div>
        <div class="opinion-item-content">{{info.customerServiceRemark || '-'}}</div>
      </div>

    </div>
    <acceptance-comments-dialog
      v-if="acceptanceCommentsVisible"
      @close="acceptanceCommentsVisible=false"
      :model="acceptanceCommentsModel"
      @success="onSuccess"
      :type="acceptanceCommentsModel.type"
    ></acceptance-comments-dialog>
  </div>
</template>

<script>
/**
 * 服务内容组件
 *
 * 案例订单-维修/保养：
 * 服务内容-图片
 * 服务内容-故障描述
 * 受理详情（优先级，受理备注：编辑）
 *
 *
 * 工单-维修/保养：
 * 工单内容-图片
 * 工单内容-故障描述
 */
import apis from '@/utils/apis';
import acceptanceCommentsDialog from './acceptance_comments_dialog';

export default {
  name: '',
  inject: ['getCaseInfo', 'checkActionEnable'],
  mixins: [],
  components: { acceptanceCommentsDialog },
  props: {
    caseOrderId: [Number, String],
    orderType: [Number, String],
    caseOrderType: [Number, String],
  },
  data() {
    return {
      imgList: [],
      acceptanceCommentsVisible: false,
      acceptanceCommentsModel: {},
    };
  },
  computed: {
    // 返修工单
    isReworkOrder() {
      return `${this.caseOrderType}` === '50';
    },
    actionEnable() {
      return this.checkActionEnable();
    },
    // 是否显示报修原因
    showReason() {
      return `${this.caseOrderType}` === '10';
    },
    // 是否展示图片
    showImg() {
      return `${this.caseOrderType}` === '10' && this.imgList.length;
    },
    info() {
      return this.getCaseInfo();
    },
  },
  watch: {
    caseOrderId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.init();
        }
      },
    },
  },
  filters: {},
  directives: {},
  methods: {
    onDel() {
      this.$postJSON(apis.caseOrderUpdateServiceRemark, {
        caseOrderId: this.info.caseOrderId,
        customerServiceRemark: '',
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.info.customerServiceRemark = '';
      });
    },
    init() {
      // this.info = {};
      // this.$getJSON(`${apis.caseOrderInfo}/${this.caseOrderId}`, {}, true).then((res) => {
      //   this.info = res.data;
      // });

      this.$getFileList({ bizId: this.caseOrderId, bizType: 'asm.service.request' }).then((list) => {
        this.imgList = list;
      });
    },
    // 修改意见
    onAccept() {
      this.acceptanceCommentsModel = {
        title: this.$t('asm_service_content.shou_li_yi_jian'),
        type: 'editCaseOpinion',
        data: this.info,
      };
      this.acceptanceCommentsVisible = true;
    },
    onSuccess() {
      this.$emit('update');
    },
  },
  created() { },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.service-content {
  padding: 16px;

  .case-order-desc {
    padding: 10px 0;
    line-height: 20px;
    font-size: 12px;
    word-break: break-all;
  }

  .item-title {
    overflow: hidden;
    .title {
    }
    .btn-edit {
      display: inline-block;
      margin-left: 10px;
      font-size: 14px;
      cursor: pointer;
      position: relative;
      top: 1px;
      color: #0d9ae0;
    }
  }

  .img-content {
    overflow: hidden;
    .img-item {
      float: left;
      margin-right: 15px;
      width: 100px;
      height: 100px;
      border-radius: 4px;
      border: 1px solid #ccc;
      position: relative;

      .img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width: 95%;
        max-height: 95%;
      }
    }
  }

  .opinion {
    margin-top: 20px;

    .opinion-item {
      margin-top: 1px;
      &:nth-child(n + 2) {
        margin-top: 20px;
      }
      &-title {
        font-size: 12px;
        font-weight: bold;
        line-height: 24px;
      }
      &-content {
        font-size: 12px;
        line-height: 20px;
        word-break: break-all;
        margin-top: 10px;
      }
    }

    .remark {
      margin-top: 15px;
      font-size: 14px;
    }
  }
}
</style>
